export enum AuthenticatorConfiguration {
  Done,
  Initial,
  Remove,
  Error,
}

export type EmailOtpSetupMode = "MFA" | "ACTIVATION";
